import {
  richtext_default
} from "./chunk-AOYEWCXX.js";

// src/blocks/richtext/index.ts
var richtext_default2 = richtext_default;

export {
  richtext_default2 as richtext_default
};
